import React from 'react';
import PropTypes from 'prop-types';
import { Container, Carousel, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CountDown from './countDown';
import CategoryLabel from '../categoryLabel';

const ParticipatesComp = ({ items }) => {
  const carouselControls = items.length > 1;

  return (
    <Container fluid className="bg-alabaster">
      <Container className="py-60" id="subastas-recomendadas">

        <Row className="justify-content-center">
          <Col xs={10} lg={12}>
            <h2 className="text-center">¡Participa con tus Puntos Aeroméxico Rewards y gana!</h2>
          </Col>
        </Row>
        <Carousel controls={carouselControls} className="with-controls d-lg-block d-xl-block mb-0 carousel-particpate pb-30">
          {items.map((i) => (
            <Carousel.Item key={i.id}>
              <Row className="pt-30">

                <Col lg={6} xl={8} className="px-0">
                  <div className="carousel-img">
                    <img className="image d-block d-sm-none" src={i.imageMob} alt={i.title} />
                    <img className="image d-none d-sm-block" src={i.imageHome} alt={i.title} />
                    <CategoryLabel
                      page="home"
                      category={i.categoria} />
                  </div>
                </Col>
                <Col lg={6} xl={4} className="bg-white py-2 px-5 pl-md-4 pr-md-5 text-tangaroa">
                  <h2 className="mt-15">
                    {i.title}
                  </h2>
                  <p>
                    {i.smallDescription}
                  </p>
                  <p className="font-weight-bold">Finaliza en</p>
                  <CountDown
                    size="middle"
                    closeDate={i.closeDate}
                    todayDate={i.serverDate} />
                  <h4 className="text-dark-blue mt-15 ml-2">
                    <i className="fas fa-coins mr-2" />
                    { `Oferta inicial: ${i.initialOffer.toLocaleString()} Puntos Aeroméxico Rewards`}
                  </h4>
                  <Link to={`/subastas/${i.urlName}/${i.id}`} className="btn btn-primary my-15 image f-600">
                    Ver detalles
                  </Link>
                </Col>
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </Container>
  );
};

ParticipatesComp.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    smallDescription: PropTypes.string.isRequired,
    imageHome: PropTypes.string.isRequired,
    initialOffer: PropTypes.number.isRequired,
    closeDate: PropTypes.string.isRequired,
    serverDate: PropTypes.string.isRequired,
    categoria: PropTypes.shape({
      title: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      iconUrl: PropTypes.string.isRequired,
    }).isRequired,
  })).isRequired,
};

export default ParticipatesComp;
